import type { PricingCategory, AdditionalFee } from '../types/pricing.types';

export const sameDayRentals: PricingCategory = {
  title: 'Same-Day Rentals (Up to 12 Hours)',
  tiers: [
    {
      id: 'four-hours',
      title: '4 Hours',
      subtitle: '(Minimum)',
      price: '$190',
    },
    {
      id: 'six-hours',
      title: '6 Hours',
      price: '$250',
    },
    {
      id: 'eight-hours',
      title: '8 Hours',
      subtitle: '(Full-Day Flex)',
      price: '$310',
    },
  ],
};

export const multiDayRentals: PricingCategory = {
  title: 'Multi-Day Rentals',
  tiers: [
    {
      id: 'two-days',
      title: '2 Days',
      price: '$225',
      priceUnit: '/day',
      totalPrice: '$450 total',
    },
    {
      id: 'three-to-six-days',
      title: '3-6 Days',
      price: '$160',
      priceUnit: '/day',
      totalPrice: '$480-$960 total',
    },
    {
      id: 'full-week',
      title: 'Full Week',
      price: '$140',
      priceUnit: '/day',
      totalPrice: '$980 total',
      isBestValue: true,
    },
    {
      id: 'seven-plus-days',
      title: '7+ Days',
      price: 'Call for',
      totalPrice: 'Long-term rates',
    },
  ],
};

export const additionalFees: AdditionalFee[] = [
  {
    label: 'Security Deposit (Refundable)',
    amount: '$300-$500',
  },
  {
    label: 'Optional Damage Waiver',
    amount: '$15/day',
  },
  {
    label: 'Add-On Packages',
    sublabel: 'Beach, Family, or Tourist Essentials',
    amount: '$20-$35',
  },
];